import { CommonModule } from '@angular/common';
import { BpBreadcrumbComponent } from './breadcrumb.component';
import { NgModule } from '@angular/core';
import { BpBreadcrumbItemComponent } from './breadcrumb-item.component';


@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        BpBreadcrumbComponent,
        BpBreadcrumbItemComponent
    ],
    exports: [
        BpBreadcrumbComponent,
        BpBreadcrumbItemComponent
    ]
})

export class BpBreadcrumbModule {
}
